import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import s from './Organizacoes.module.css';

export default function Organizacoes() {
  const navigate = useNavigate();
  const [organizacoes, setOrganizacoes] = useState([]);
  const [busca, setBusca] = useState('');
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    setLoading(true);
    setErro('');
    api.get('/organizacoes')
      .then(res => setOrganizacoes(res.data))
      .catch(() => setErro('Erro ao carregar organizações.'))
      .finally(() => setLoading(false));
  }, []);

  const filtradas = organizacoes.filter(o => {
    const q = busca.toLowerCase();
    return (
      (o.razao_social || '').toLowerCase().includes(q) ||
      (o.cnpj || '').includes(q) ||
      (o.cidade || '').toLowerCase().includes(q)
    );
  });

  return (
    <div className={s.erpWrap}>
      <div className={s.titleBar}>
        🏢 Organizações
      </div>

      <div className={s.toolbar}>
        <input
          className={s.busca}
          type="text"
          placeholder="Buscar por razão social, CNPJ ou cidade..."
          value={busca}
          onChange={e => setBusca(e.target.value)}
        />
        <button
          className={s.btnErpPrimario}
          onClick={() => navigate('/admin/organizacoes/novo')}
        >
          + Nova Organização
        </button>
      </div>

      <div className={s.conteudo}>
        {loading && <p>Carregando...</p>}

        {!loading && erro && (
          <p className={s.erroMsg}>{erro}</p>
        )}

        {!loading && !erro && (
          <div className={s.tabelaWrap}>
            <table className={s.tabela}>
              <thead>
                <tr>
                  <th>Razão Social</th>
                  <th>CNPJ</th>
                  <th>Cidade/UF</th>
                  <th>Ambiente</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {filtradas.length === 0 ? (
                  <tr>
                    <td colSpan={6} style={{ textAlign: 'center', color: '#888', padding: '12px' }}>
                      Nenhuma organização encontrada.
                    </td>
                  </tr>
                ) : (
                  filtradas.map(org => (
                    <tr key={org.id}>
                      <td>{org.razao_social}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>{org.cnpj}</td>
                      <td>
                        {org.cidade && org.uf
                          ? `${org.cidade}/${org.uf}`
                          : org.cidade || org.uf || '—'}
                      </td>
                      <td>
                        {org.ambiente_nfe === 'producao' ? (
                          <span className={s.badgeProd}>Produção</span>
                        ) : (
                          <span className={s.badgeHome}>Homologação</span>
                        )}
                      </td>
                      <td>
                        {org.ativo ? (
                          <span className={s.badgeAtivo}>Ativo</span>
                        ) : (
                          <span className={s.badgeInativo}>Inativo</span>
                        )}
                      </td>
                      <td>
                        <button
                          className={s.btnErp}
                          onClick={() => navigate(`/admin/organizacoes/editar/${org.id}`)}
                        >
                          Editar
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
